import "../components/about/aboutUs.css";
import AboutUs from "../components/about/AboutUs";

const About = () => {
  return (
    <>
      <div className="about-page">
        <AboutUs />
      </div>
    </>
  );
};

export default About;
